var _path, _circle, _circle2, _path2, _circle3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTool8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72214 17.7157C5.24419 17.3652 4.86788 16.9277 4.59837 16.4412C4.41353 16.1075 4.12994 15.8333 3.78314 15.6744C3.48224 15.5366 3.19068 15.3665 2.91342 15.1632C0.702576 13.5417 0.225057 10.4351 1.84641 8.22406C2.07773 7.90865 2.33935 7.62871 2.62425 7.38503C2.89269 7.15544 3.08192 6.84518 3.17678 6.50493C3.30185 6.05633 3.50845 5.6223 3.80014 5.22452C5.09728 3.45561 7.58269 3.07321 9.35161 4.37032C9.79394 4.69468 10.4155 4.59905 10.7398 4.15672C12.037 2.38779 14.5224 2.00537 16.2913 3.30252C18.0602 4.59968 18.4426 7.08508 17.1455 8.85399C16.8211 9.29632 16.9168 9.91784 17.3591 10.2422C19.1279 11.5394 19.5104 14.0248 18.2133 15.7937C16.9162 17.5625 14.4307 17.9449 12.6618 16.6479C12.2195 16.3235 11.598 16.4191 11.2736 16.8615C9.97641 18.6301 7.49097 19.0127 5.72214 17.7157Z",
    fill: "#B9D6DE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.96049,
    cy: 10.9894,
    r: 4.17037,
    transform: "rotate(-143.747 6.96049 10.9894)",
    fill: "#62A1B3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7634,
    cy: 11.0917,
    r: 3.17743,
    fill: "#B9D6DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58594 11.0917C9.58594 9.33689 11.0085 7.91431 12.7634 7.91431",
    stroke: "#8CBBC8",
    strokeWidth: 0.993699,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.32715,
    cy: 13.4669,
    r: 3.17743,
    transform: "rotate(45 7.32715 13.4669)",
    fill: "#B9D6DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08037 15.7137C3.83951 14.4729 3.83951 12.461 5.08037 11.2202C6.32123 9.97931 8.33307 9.97931 9.57393 11.2202",
    stroke: "#8CBBC8",
    strokeWidth: 0.993699,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool8);
export default __webpack_public_path__ + "static/media/tool_8.e7fa1e17704ac2a014eb409daafd5d6c.svg";
export { ForwardRef as ReactComponent };